export const LaboratoryReportTypes = {
  LAB_PRODUCT_TEST_REPORT: {ID : "LabProductTestReport", TRANSLATION_KEY : "labProductTestReport"},
  FAILURE_REPORT: { ID : "FailureReport", TRANSLATION_KEY: "failureReport"}
};